export const APP_LOAD_TIME_TO_INIT_TRACKED =
  'acornsweb_app_load_time_to_init_tracked'
export const APP_LOAD_START = 'acornsweb_app_load_start'
export const APP_LOAD_START_INIT = 'acornsweb_app_load_start_init'
